const flavorConfigByName = {
  globalworth: {
    supportedLanguageCodes: ['en', 'pl', 'ro', 'uk'],
  },
}

module.exports = {
  flavorConfigByName,
}
